import React from "react";
/* import { Row } from "antd";
import { useIntl } from "react-intl";

import Service from "./service";
import ServiceWithDate from "./serviceWithDate"; */

function ErServices({
  disabled,
  formItemLayout,
  initialServices,
  getFieldDecorator,
}) {
  //const intl = useIntl();
  return (
    <div>
      {/* <Service
          disabled={disabled}
          fieldName="deliveryProof"
          label={intl.formatMessage({
            id: "consignment.services.pod",
            defaultMessage: "Tisk informace o doručení (POD)",
          })}
          getFieldDecorator={getFieldDecorator}
          initialValue={initialServices && initialServices.deliveryProof}
        />
      <ServiceWithDate
        disabled={disabled}
        label={intl.formatMessage({
          id: "consignment.services.deliveryDate",
          defaultMessage: "Datum doručení",
        })}
        fieldName="deliveryDateTime"
        formItemLayout={formItemLayout}
        getFieldDecorator={getFieldDecorator}
        initialServiceDate={initialServices && initialServices.deliveryDateTime}
      /> */}
    </div>
  );
}

export default ErServices;
